import styled from "styled-components";

export const Separador = styled.img`
    width: 1525px;
    display: block;
    margin-top: -7em;
    height: auto;
`